import { ViewBasicInterface } from 'pf-frontend-common/src/module/view/basic.interface';

import { ContentGroupView } from 'common/module/content-group/view';
import { StatsServiceInterface } from 'common/service/stats/service.interface';
import { TermsAndConditionsPageTabViewOptionsInterface } from 'desktop/module/terms-and-conditions/page/tab-view-options.interface';
import { TermsAndConditionsPageViewOptionsInterface } from 'desktop/module/terms-and-conditions/page/view-options.interface';

export class TermsAndConditionsPageView implements ViewBasicInterface {
  /**
   * @inheritDoc
   */
  protected element: HTMLElement;

  /**
   * Constructor
   */
  constructor(private tabView: ContentGroupView, private statsService: StatsServiceInterface) {}

  /**
   * @inheritDoc
   */
  public initialize(options: TermsAndConditionsPageViewOptionsInterface): void {
    this.element = options.element;

    this.initTabView(options.subview.tab.viewOptions);
  }

  /**
   * @inheritDoc
   */
  public render(): void {
    this.tabView.render();

    // Log stats
    this.stats();
  }

  /**
   * Log stats for the page
   */
  private stats(): void {
    // Log stats
    this.statsService.pageView();
  }

  /**
   * Initialize tabs
   */
  private initTabView(viewOptions: TermsAndConditionsPageTabViewOptionsInterface): void {
    this.tabView.initialize(viewOptions);
  }
}
